import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map'
import {SearchRequest} from "../_models/searchRequest";
import {Router} from "@angular/router";
import {SearchResult} from "../_models/searchResult";

@Injectable()
export class SearchService {
    constructor(private http: Http,
                private router: Router) {
    }

    search(searchRequest: SearchRequest): Promise<SearchResult> {
        let headers = new Headers();
        headers.append('X-Requested-With', 'XMLHttpRequest');
        headers.append('Content-Type', 'application/json');
        headers.append('Cache-Control', 'no-cache');
        return this.http.post('/api/search', JSON.stringify({
            name: searchRequest.name,
            address: searchRequest.address,
            phoneNumber: searchRequest.phoneNumber
        }), {headers: headers})
            .toPromise().then( response => {
                let result = response.json();
                return result as SearchResult;
            });

    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/_services/search.service.ts